import React from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import {
  BarChart2,
  Users,
  Calendar,
  Award,
  ClipboardCheck,
  Bell,
  MessageSquare,
  Settings,
  LogOut,
  ChevronLeft,
  MapPin,
  Download,
  Mic,
} from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const AdminSidebar = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      logout();
      navigate("/login");
    }
  };

  const navItems = [
    {
      icon: <BarChart2 size={20} />,
      label: "Dashboard",
      path: eventId ? `/admin/event/${eventId}` : "/admin",
    },
    {
      icon: <Users size={20} />,
      label: "Users",
      path: eventId ? `/admin/event/${eventId}/users` : "/admin/users",
    },
    {
      icon: <Mic size={20} />,
      label: "Speakers",
      path: eventId ? `/admin/event/${eventId}/speakers` : "/admin/speakers",
    },
    {
      icon: <Calendar size={20} />,
      label: "Sessions",
      path: eventId ? `/admin/event/${eventId}/sessions` : "/admin/sessions",
    },
    {
      icon: <Award size={20} />,
      label: "Masterclasses",
      path: eventId
        ? `/admin/event/${eventId}/masterclasses`
        : "/admin/masterclasses",
    },
    {
      icon: <ClipboardCheck size={20} />,
      label: "Attendance",
      path: eventId
        ? `/admin/event/${eventId}/attendance`
        : "/admin/attendance",
    },
    {
      icon: <MapPin size={20} />,
      label: "Venues",
      path: eventId ? `/admin/event/${eventId}/venues` : "/admin/venues",
    },
    {
      icon: <Bell size={20} />,
      label: "Notifications",
      path: eventId
        ? `/admin/event/${eventId}/notifications`
        : "/admin/notifications",
    },
    {
      icon: <Download size={20} />,
      label: "Downloads",
      path: eventId ? `/admin/event/${eventId}/downloads` : "/admin/downloads",
    },
  ];

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-header">
        <div className="admin-logo">
          <b>RF Admin</b>
          <span>admin@rfconference.com</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            end={item.label === "Dashboard"}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button className="nav-item" onClick={() => navigate("/")}>
          <ChevronLeft size={20} />
          <span>Exit Admin</span>
        </button>
        <button
          className="nav-item logout"
          onClick={handleLogout}
          style={{ color: "#ef4444" }}
        >
          <LogOut size={20} />
          <span>Log Out</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
